import { ContactDetails } from 'models';

export const messages: ContactDetails[] = [
	{
		userId: '12',
		contactName: 'shawky Sobhy',
		chat: [
			{
				id: '28',
				message:
					'hello , i am asking question about hello , i am asking question abouthello , i am asking question about',
				date: new Date('2-20-2022 03:24:01'),
			},
			{
				id: '12',
				message: 'hello , i am asking question about',
				date: new Date('2-20-2022 03:24:02'),
			},
			{
				id: '28',
				message:
					'fdshello , i am asking question about hello , i am asking question abouthello , i am asking question about',
				date: new Date('2-20-2022 03:24:03'),
			},
			{
				id: '12',
				message: 'ewrhello , i am asking question about',
				date: new Date('2-20-2022 03:24:04'),
			},
			{
				id: '28',
				message:
					'xdfhello , i am asking question about hello , i am asking question abouthello , i am asking question about',
				date: new Date('2-20-2022 03:24:05'),
			},
			{
				id: '12',
				message: 'dfshello , i am asking question about',
				date: new Date('2-20-2022 03:24:23'),
			},
		],
	},
	{
		userId: '13',
		contactName: 'Wagih Mohamed',
		chat: [
			{
				id: '502',
				message: 'hello , i am asking question about',
				date: new Date('1-20-2022 03:24:50'),
			},
			{
				id: '13',
				message: 'hello , i am asking question about',
				date: new Date('1-20-2022 03:24:12'),
			},
		],
	},
	{
		userId: '14',
		contactName: 'Ali Kehel',
		chat: [
			{
				id: '502',
				message: 'hello , i am asking question about',
				date: new Date('5-20-2022 03:24:45'),
			},
			{
				id: '14',
				message: 'hello , i am asking question about',
				date: new Date('5-20-2022 03:34:14'),
			},
		],
	},
	{
		userId: '15',
		contactName: 'Abdelmonem anwer',
		chat: [
			{
				id: '502',
				message: 'hello , i am asking question about',
				date: new Date('6-5-2022 03:24:54'),
			},
			{
				id: '15',
				message: 'hello , i am asking question about',
				date: new Date('6-5-2022 03:24:59'),
			},
		],
	},
];
